import { Form, ModalDialog } from "@rothoblaas/design-system";
import { FC, useContext } from "react";
import FormFieldsContainer from "../../../../components/ui/FormFieldsContainer";
import TranslatableTextField from "../../../../components/ui/TranslatableTextField";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../../context/notificationContext";
import useI18n from "../../../../hooks/useTranslations";
import type { CondCategory, CondCategoryBody } from "../../../../http/envelopeDesigner/types/condCategory";
import { useMaterialClassificationApi } from "../../../../http/envelopeDesigner/useAdminEnvelopeDesigner";

// An admissible-condensate category: its name and its rule in every language (its code is the calculation's).
const CondCategoryFormDialog: FC<{ condCategory: CondCategory; onClose: () => void }> = ({ condCategory, onClose }) => {
  const i18n = useI18n();
  const t = i18n.translation.envelopeDesignerModule.admin;
  const dispatch = useContext(NotificationDispatch);
  const classificationApi = useMaterialClassificationApi();

  const defaultValues: CondCategoryBody = {
    name: condCategory.name,
    nameIt: condCategory.nameIt,
    nameDe: condCategory.nameDe,
    nameFr: condCategory.nameFr,
    nameEs: condCategory.nameEs,
    rule: condCategory.rule,
    ruleIt: condCategory.ruleIt,
    ruleDe: condCategory.ruleDe,
    ruleFr: condCategory.ruleFr,
    ruleEs: condCategory.ruleEs,
  };

  const onSubmit = () => async (formData: CondCategoryBody) => {
    try {
      await classificationApi.condCategories.update(condCategory.code, {
        ...formData,
        nameIt: formData.nameIt || null,
        nameDe: formData.nameDe || null,
        nameFr: formData.nameFr || null,
        nameEs: formData.nameEs || null,
        ruleIt: formData.ruleIt || null,
        ruleDe: formData.ruleDe || null,
        ruleFr: formData.ruleFr || null,
        ruleEs: formData.ruleEs || null,
      });
      dispatch(showSuccessNotification(i18n.translation));
      onClose();
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    }
  };

  return (
    <ModalDialog onClose={onClose} title={`${i18n.translation.common.edit} ${t.condCategory}`}>
      <Form<CondCategoryBody>
        submitText={i18n.translation.common.save}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
      >
        {(form) => (
          <FormFieldsContainer fullWidth>
            <TranslatableTextField form={form} />
            <TranslatableTextField form={form} field="rule" label={t.rule} />
          </FormFieldsContainer>
        )}
      </Form>
    </ModalDialog>
  );
};

export default CondCategoryFormDialog;
